import { CLOSED_PROJECT_STATUSES, type ProjectStatus } from '@fos/shared/contracts/projects';
import { PROJECT_KIND_LABELS } from '@fos/shared/labels';
import { todayLocal } from '@fos/shared/time';

/** Godziny z sekund: całe bez przecinka („32”), inaczej jedno miejsce po przecinku („1,8”). */
export function formatHours(seconds: number): string {
  const tenths = Math.round((seconds / 3600) * 10);
  if (tenths % 10 === 0) return String(tenths / 10);
  return (tenths / 10).toFixed(1).replace('.', ',');
}

/** Wykorzystanie budżetu: „32 / 40 h”, bez budżetu „12 h”, bez czasu i budżetu: null. */
export function projectHoursText(usedSeconds: number, budgetSeconds: number | null | undefined): string | null {
  if (budgetSeconds) return `${formatHours(usedSeconds)} / ${formatHours(budgetSeconds)} h`;
  if (usedSeconds > 0) return `${formatHours(usedSeconds)} h`;
  return null;
}

/** Podpis wiersza: „REA · projekt”, „Fravity · wewnętrzny”, „projekt” (bez klienta). */
export function projectSubtitle(
  p: { isInternal: boolean; client: { name: string } | null },
  workspaceName: string | null | undefined,
): string {
  if (p.isInternal) return [workspaceName, PROJECT_KIND_LABELS.internal].filter(Boolean).join(' · ');
  return [p.client?.name, PROJECT_KIND_LABELS.project].filter(Boolean).join(' · ');
}

/** Termin minął, a projekt nadal otwarty (czerwony tylko po terminie, DESIGN §2). */
export function isProjectOverdue(
  p: { endDate: string | null; status: ProjectStatus; archivedAt: Date | string | null },
  today: string = todayLocal(),
): boolean {
  if (!p.endDate || p.archivedAt) return false;
  if ((CLOSED_PROJECT_STATUSES as readonly string[]).includes(p.status)) return false;
  return p.endDate < today;
}

/** „40” albo „12,5” (h) → sekundy; pusty tekst = null; błędna wartość = undefined. */
export function parseHoursInput(text: string): number | null | undefined {
  const t = text.trim().replace(',', '.').replace(/\s*h$/i, '');
  if (!t) return null;
  if (!/^\d{1,6}(\.\d{1,2})?$/.test(t)) return undefined;
  const seconds = Math.round(Number(t) * 3600);
  return seconds > 0 ? seconds : undefined;
}

/** Sekundy → tekst pola „Budżet godzin” („40”, „12,5”). */
export function hoursInputValue(seconds: number | null | undefined): string {
  if (!seconds) return '';
  const h = Math.round((seconds / 3600) * 100) / 100;
  return String(h).replace('.', ',');
}
